var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-layout',{attrs:{"layout":['xs12']}},[_c('l-data-table',{attrs:{"headers":_vm.header,"get-data-func":_vm.getApplList,"hide-title-search":"","title-text":"个人申请历史","clickable":""},on:{"click:row":function($event){return _vm.getDetails($event.item)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }